<template>
  <div class="bill-detail">
    <header class="main_menu">
        <div class="container">
            
            <div class="row align-items-center">
                <div class="col-lg-12"> 
                <nav class="navbar navbar-expand-lg navbar-light">
                        <a class="navbar-brand" :href="'#/order/history/'+this.session_id"> <i style="background: #f7f7f7; padding: 4px 5px; border-radius: 5px; box-shadow: 2px 2px #d1cfcf; font-size: 12px;" class="fas fa-chevron-left"></i> </a>
						<a class="navbar-brand mr-auto" :href="'#/menu/'+restaurant_id+'/'+table_id"> <img :src="this.logo" style="object-fit: contain; max-height: 42px; border-radius: 33%;" @error="ResimageLoadError" alt="logo"> </a>
                        
						<ul style="margin-bottom: 0;padding-left:0;">
                        <li>
                        <i class="fas fa-globe  dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="font-size: 16px;margin-right: 20px; padding-top: 5px;"></i>
                            <div class="dropdown-menu bgs" style="box-shadow: 2px 2px 7px #a7a7a7; left:auto; right:0;">
                            <a @click="handleChange('en-us')" :style="{color: eng_lang ? 'red' : '#000000'}" class="dropdown-item" data-value="en"> <flag iso="us" /> English</a>
                            <!-- <a @click="handleChange('th')" :style="{color: thai_lang ? 'red' : '#000000'}" class="dropdown-item" data-value="th"> <flag iso="th" /> ไทย </a>
                            <a @click="handleChange('ja')" :style="{color: jap_lang ? 'red' : '#000000'}" class="dropdown-item" data-value="th"> <flag iso="jp" /> 日本 </a>
                            <a @click="handleChange('ko')" :style="{color: ko_lang ? 'red' : '#000000'}" class="dropdown-item" data-value="th"> <flag iso="kp" /> 韓国語 </a>
                            <a @click="handleChange('it')" :style="{color: it_lang ? 'red' : '#000000'}" class="dropdown-item" data-value="th"> <flag iso="it" /> italiano</a>
                            <a @click="handleChange('zh-hans')" :style="{color: ch_lang ? 'red' : '#000000'}" class="dropdown-item" data-value="th"> <flag iso="cn" /> 简体中文</a> -->
                            <template v-for="lang in this.lang_list" :key="lang.id">
                                <a
                                @click="handleChange(lang.language)"
                                :style="{ color: lang_select == lang.language ? 'red' : '#000000' }"
                                class="dropdown-item"
                                data-value="th"
                            >
                            <template v-if="lang.language == 'uk'"> <flag iso="ua" /> {{lang.country}} </template> <template v-else> <flag :iso="lang.language" /> {{lang.country}} </template>
                            </a>
                            </template>
                            </div> 
                        </li>
                        </ul>
						<a style="margin-right: 1px;" class="navbar-brand" v-on:click="refreshpage()"><i class="fas fa-redo-alt" style="font-size: 16px;"></i></a>
						<ul style="margin-bottom: 0;padding-left:0;">
						<li>
							<!-- <i style="margin-left: 13px;" class="fas fa-ellipsis-v dropdown-toggle-split"
                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i> -->
                          <a :href="'#/order/history/'+session_id" class="dropdown-item" style="padding: 0.25rem 0rem 0.25rem 1rem;background-color: #fff;"><i class="fas fa-shopping-cart"></i></a>
							<!-- <div class="dropdown-menu bgs" style="box-shadow: 2px 2px 7px #a7a7a7; left:auto; right:0;">
								<a class="dropdown-item" v-on:click="addHelp();"> <i class="fas fa-concierge-bell"> {{ $t("message.help", {}, { locale: lang }) }} </i></a>
								<a :href="'#/restaurant/order/history/'+session_id" class="dropdown-item"><i class="fas fa-clipboard-list">  {{ $t("message.orderstatus", {}, { locale: lang }) }}</i></a>
							</div>	 -->
						</li>		
						</ul>

                        
                </nav>
                </div>
                
            </div>
        </div>
    </header>
    <div v-if="isLoading" style="text-align:center">
         <img src="" style="margin-top:120px;" @error="Loader" alt="logo">
    </div>
    <section class="blog_item_section">
      <div class="container" v-show="isLoaded" @load="loaded">
    <div class="row mt-3">
      
      <div class="col-6">
        <p style="font-size: 11px;">
          <span style="color:#000; font-weight:700;">{{ $t("message.orderid", {}, { locale: lang }) }}</span> <br />
          {{order_id}}
        </p>
      </div>
      <div class="col-6" style="text-align: right;">
        <span style="color:#000;font-size: 11px;">{{ $t("message.date", {}, { locale: lang }) }} {{this.mydate}}</span><br>
        <span style="color:#000;font-size: 11px;">{{ $t("message.time", {}, { locale: lang }) }} {{this.timeString}}</span>
      </div>
    </div>

    <div class="row">
      
      <table class="table table-borderless" style="margin:0 14px;">
        <thead>
          <tr
            style="border-bottom: dashed; border-top:dashed; border-top-color:#cbcbcb; border-bottom-color: #cbcbcb; color: #ffac48;"
          >
            <th scope="col">{{ $t("message.order", {}, { locale: lang }) }}</th>
            <th scope="col">{{ $t("message.qty", {}, { locale: lang }) }}</th>
            <th scope="col">{{ $t("message.rate", {}, { locale: lang }) }}</th>
            <th scope="col">{{ $t("message.price", {}, { locale: lang }) }}</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="item_with_taxes.length">
          <template v-for="item in item_with_taxes" :key="item.id" >
            <tr v-for="item_with_extra in item.order_detail" :key="item_with_extra">
                  <td>{{item_with_extra.item_name}} <tr> <span v-for="extra_item in item_with_extra.extra_item" :key="extra_item.id" class="item_ls" style="color: #939393;
    font-size: 12px;">{{extra_item.extra_item}}</span></tr></td>
                  <td>{{item_with_extra.item_count}}</td>
                  <td>{{parseFloat(item_with_extra.item_price).toFixed(2) }}<tr> <span v-for="extra_item in item_with_extra.extra_item" :key="extra_item.id" class="item_ls" style="color: #939393;
    font-size: 12px;">{{parseFloat(extra_item.price).toFixed(2)}}</span></tr></td>
                  <!-- <td>{{parseFloat(item_with_extra.item_total_price).toFixed(2) }}</td> -->
                  <template v-if="item_with_extra.extra_item.length != 0">
                <td :style="{ 'position': 'relative', top: item_with_extra.extra_item.length * 18 + 'px' }">{{parseFloat(item_with_extra.item_total_price).toFixed(2) }}</td>
                </template>
                <template v-else>
                  <td>{{parseFloat(item_with_extra.item_total_price).toFixed(2) }}</td>
                </template>
            </tr>
            <!-- <td>{{item.order_detail[0].item_name}}</td>
            <td>{{item.order_detail[0].item_count}}</td>
            <td>{{currency}} {{item.order_detail[0].item_price}}</td>
            <td>{{currency}} {{item.order_detail[0].item_total_price}}</td> -->

            <!-- <td>{{item.order_detail[1].item_name}}</td>
            <td>{{item.order_detail[1].item_count}}</td>
            <td>{{currency}} {{item.order_detail[1].item_price}}</td>
            <td>{{currency}} {{item.order_detail[1].item_total_price}}</td> -->
          </template>
          </template>
          <tr style="border-top:dashed; border-top-color:#cbcbcb;"></tr>

          <template v-if="this.first_total !=0">
          <tr>
            <td></td>
            <td></td>
            <td>{{ $t("message.subtotal", {}, { locale: lang }) }}</td>
            <td>{{currency}} {{parseFloat(this.first_total).toFixed(2) }}</td>
          </tr>
          </template>
          <tr v-for="tax in tax_calculation" :key="tax.id" >
            <td></td>
            <td></td>
            <td>{{tax.tax_name}}</td>
            <td>{{parseFloat(tax.tax_amount).toFixed(2) }}</td>
          </tr>
          <tr style="border-bottom: dashed; border-bottom-color:#cbcbcb;"></tr>

          <template v-for="item in item_without_taxes" :key="item.id">
            <tr v-for="item_with_extra in item.order_detail" :key="item_with_extra">
            <!-- <td>{{item.order_detail[0].item_name}}</td>
            <td>{{item.order_detail[0].item_count}}</td>
            <td>{{currency}} {{item.order_detail[0].item_price}}</td>
            <td>{{currency}} {{item.order_detail[0].item_total_price}}</td> -->
                <td>{{item_with_extra.item_name}}<tr> <span v-for="extra_item in item_with_extra.extra_item" :key="extra_item.id" class="item_ls" style="color: #939393;
    font-size: 12px;">{{extra_item.extra_item}}</span></tr> </td>
                <td>{{item_with_extra.item_count}}</td>
                <td>{{parseFloat(item_with_extra.item_price).toFixed(2) }}<tr> <span v-for="extra_item in item_with_extra.extra_item" :key="extra_item.id" class="item_ls" style="color: #939393;
    font-size: 12px;">{{parseFloat(extra_item.price).toFixed(2)}}</span></tr> </td>
                <template v-if="item_with_extra.extra_item.length != 0">
                <td :style="{ 'position': 'relative', top: item_with_extra.extra_item.length * 18 + 'px' }">{{parseFloat(item_with_extra.item_total_price).toFixed(2) }}</td>
                </template>
                <template v-else>
                  <td>{{parseFloat(item_with_extra.item_total_price).toFixed(2) }}</td>
                </template>
            </tr>
          </template>
          <tr style="border-top:dashed; border-top-color:#cbcbcb;"></tr>
          <tr v-if="this.second_total>0">
            <td></td>
            <td></td>
            <td>{{ $t("message.subtotal", {}, { locale: lang }) }}</td>
            <td>{{currency}} {{parseFloat(this.second_total).toFixed(2) }}</td>
          </tr>

          <tr v-if="this.service_fee_amount>0">
            <td></td>
            <td></td>
            <td>{{ $t("message.servicecharge", {}, { locale: lang }) }}</td>
            <td>{{currency}} {{parseFloat(this.service_fee_amount).toFixed(2) }}</td>
          </tr>

          <tr v-if="this.tip>0">
            <td></td>
            <td></td>
            <td>{{ $t("message.tip", {}, { locale: lang }) }}</td>
            <td>{{currency}} {{parseFloat(this.tip).toFixed(2) }}</td>
          </tr>

          <tr>
            <td></td>
            <td></td>
            <td>{{ $t("message.billtotal", {}, { locale: lang }) }}</td>
            <td>{{currency}} {{parseFloat(this.bill_amount).toFixed(2) }}</td>
          </tr>

          <tr v-if="this.discount>0">
            <td></td>
            <td></td>
            <td>{{ $t("message.discount", {}, { locale: lang }) }}</td>
            <td>{{parseFloat(this.discount).toFixed(2) }}</td>
          </tr>

          
          
          <tr style="border-bottom: dashed; border-top:dashed; border-top-color:#cbcbcb; border-bottom-color:#cbcbcb; background: #f3f3f3;">
            <td></td>
            <td></td>
            <td style="text-align: right;">{{ $t("message.paidamount", {}, { locale: lang }) }}</td>
            <td>{{currency}} {{parseFloat(this.grand_total).toFixed(2) }}</td>
          </tr>

        </tbody>
      </table>
    </div>
      <!-- Tips -->
            <div class="row">
                <div class="col">
                    <div id="m1">  
                        <p class="menu-title">{{ $t("message.tipyourwaiter", {}, { locale: lang }) }}</p>
                    </div>
                </div>
            </div>
            <div class="row" style="margin: 0px 0px 85px; border-radius:11px;box-shadow: 0px 1px 2px 1px rgb(205 205 205);padding: 10px 0;background-image: linear-gradient(to right, #ffffff , #ffffff);">
      <div class="col-12 mb-2">
          <p style="font-family: Okra,Helvetica,sans-serif !important; color:#5a5353; margin-bottom: 0px;line-height: 1.1;font-size: 20px;">{{ $t("message.tipdesc", {}, { locale: lang }) }}</p>
      </div>
                
                <div class="col-12">
						<button :class="{ tips: this.tipSelected==index }" @click="addTip(tip.tips_amount, index)" v-for="(tip, index) in this.tip_list" :key="tip.id" :id="index" class="tip btn-sm mt-1 mr-1">{{tip.tips_amount}}% <span v-show="this.tipSelected ==index "><img style="width: 18px;  margin-bottom: 2px;" src="@/assets/website/img/cancel.png"></span></button>
				
						<!-- <a @click="addTip($event,2)" :style="{selected:2 == selected}" class="tip btn-sm mt-1 mr-1">20% </a>
				
						<a @click="addTip($event,3)" :style="{selected:3 == selected}" class="tip btn-sm mt-1 mr-1">30% </a> -->
				
						<button :class="{ tips: this.tipSelected==index }" class="tip btn-sm mt-1" id='4' @click="otherAmount(4)">{{ $t("message.other", {}, { locale: lang }) }} <span v-show="this.tipSelectedOther"><img style="width: 18px;  margin-bottom: 2px;" src="@/assets/website/img/cancel.png"></span></button>
				</div>
                <div class="col-12">
					<form>
                        <input class="form-control"  style="border: 0; border-bottom: 1px solid #000;text-align: left;" type="number" v-model="this.amount" id="txtPassportNumber"  v-on:keyup="removeDisabled()" :placeholder="$t('message.entertip', {}, { locale: lang })" required v-show="this.isOther">
                        <input
                    id="btnSubmit"
                    type="button"
                    :value="$t('message.addt', {}, { locale: lang })"
                    v-show=this.isAdd
                    @click="tipAmount()"
                    style="background: #fff;
        color: red;            
    border: 0px;
    position: absolute;
    width:auto;
    top: 7px;
    right:25px;"


                  />
                  <input
                    id="btnClear"
                    type="button"
                    :value="$t('message.clear', {}, { locale: lang })"
                    v-show=this.isclear
                    @click="clearTip()"
                    style="background: #fff;
        color: red;            
    border: 0px;
    position: absolute;
    width:auto;
    top: 7px;
    right:25px;"


                  />
                    </form>        
				</div>
                
            </div>  
            <!-- Tips -->
      
      <!-- <div class="col-md-12 text-center mt-3">
          <button type="button" v-on:click="openModal();" class="genric-btn btn-sm danger circle mb-1" style="font-size:12px; box-shadow: 2px 2px 7px #a7a7a7;">
          {{ $t("message.getbill", {}, { locale: lang }) }}
          </button>
			</div>
      
      <div class="col-md-12 text-center mt-3">
          <button type="button" v-on:click="finishOrder();" class="genric-btn btn-sm danger circle mb-1" style="font-size:12px; box-shadow: 2px 2px 7px #a7a7a7;">
          {{ $t("message.finish", {}, { locale: lang }) }}
          </button>
			</div> -->

      <form id="payment_form" method="post" name="redirect" action="https://test.ccavenue.com/transaction/transaction.do?command=initiateTransaction">
          <input type="text" name="encRequest" :value="encRequest" hidden>
          <input type="text" name="access_code" :value="access_code" hidden>
          <input type="submit" value="submit" hidden>
      </form>

      <!-- <div class="col-md-12 text-center mt-3" v-if="this.order_status != 'Success'">
        <label style="margin-right:5px;">{{ $t("message.paymentmode", {}, { locale: lang }) }} </label>
        <div class="custom-control custom-radio custom-control-inline">
          <input
            type="radio"
            id="customRadioInline1"
            name="customRadioInline1"
            class="custom-control-input"
            v-model="x"
            value="online"
          />
          <label class="custom-control-label" for="customRadioInline1"
            >{{ $t("message.online", {}, { locale: lang }) }} </label
          >
        </div>
        <div class="custom-control custom-radio custom-control-inline">
          <input
            type="radio"
            id="customRadioInline2"
            name="customRadioInline1"
            class="custom-control-input"
            v-model="x"
            value="offline"
          />
          <label class="custom-control-label" for="customRadioInline2"
            >{{ $t("message.offline", {}, { locale: lang }) }} </label
          >
        </div>

        <button v-show="x === 'online'" v-on:click="payOnline();" class="genric-btn primary circle mb-3 mt-2"
          style="font-size:15px; box-shadow: 2px 2px 7px #a7a7a7;">
          {{ $t("message.proceed", {}, { locale: lang }) }}
        </button>
        <button v-show="x === 'offline'" v-on:click="payOffline();" class="genric-btn primary circle mb-3 mt-2"
          style="font-size:15px; box-shadow: 2px 2px 7px #a7a7a7;">
          {{ $t("message.finish", {}, { locale: lang }) }}
        </button>
      </div> -->
      

      <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                <div class="modal-body">
                  <button type="button" data-dismiss="modal" aria-label="Close" class="close"><span aria-hidden="true">×</span></button>
                    <form>
                    <div class="mb-3">
                        <label for="email-address" class="col-form-label">{{ $t("message.email", {}, { locale: lang }) }}:</label>
                        <input type="email" class="form-control" id="email-address" :placeholder="$t('message.entermail' , {}, { locale: lang })">
                    </div>
                    </form>
                </div>
                <div class="modal-footer" style="justify-content: center;">
                    <!-- <button type="button" class="genric-btn danger circle" data-dismiss="modal">{{ $t("message.close", {}, { locale: lang }) }}</button> -->
                    <button type="button" class="genric-btn primary circle" style="font-size:15px; box-shadow: 2px 2px 7px #a7a7a7;" v-on:click="sendBill();">{{ $t("message.sendbill", {}, { locale: lang }) }}</button>  
                </div>
                </div>
                </div>
                </div>
              
    
      </div>
    </section>
    <section class="bottom-cart">
        <div class="container">
            <div class="row">
			<div class="col btn-group mt-2 mb-2" style="z-index: 9999;"> 			
				<button type="button" v-on:click="openModal();" class="btn btn-danger">{{ $t("message.getbill", {}, { locale: lang }) }}</button>&nbsp;
        <button type="button" v-on:click="finishOrder();" class="btn btn-danger">{{ $t("message.finish", {}, { locale: lang }) }}</button>
      </div>
      
			</div>
            
		</div>	
    </section>
  </div>
</template>

<script>

import "@meforma/vue-toaster";
import moment from 'moment';
export default {
  name: 'BillDetail',
  data: function (){
    return {
      tax_calculation:[],
      grand_total: null,
      first_total: null,
      second_total: null,
      discount: null,
      discounted_value: null,
      discount_type: null,
      bill_amount: null,
      items: [],
      item_with_taxes:[],
      item_without_taxes: [],
      service_fee_amount: null,
      created_at: null,
      order_id: null,
      restaurant_id:null,
      table_id:null,
      currency:null,
      lang: "",
      eng_lang: false,
      thai_lang: false,
      jap_lang: false,
      ko_lang: false,
      it_lang: false,
      ch_lang: false,
      ro_lang: false,
      ru_lang: false,
      uk_lang: false,
      html_data: '',
      encRequest: '',
      access_code: '',
      x: 'online',
      order_status: '',
      isLoaded: false,
      isLoading: false,
      tip:null,
      isOther: false,
      isAdd: false,
      filterStyle: false,
      selected: null,
      tip_list: [],
      tipSelected: null,
      total_cart_amount_without_tip: null,
      tipSelectedOther: null,
      isclear: false,
      index: null,
      lang1: false,
      lang2: false,
      lang_list: [],
      lang_select: ''

      
    }
  },
  methods : {
    
    loaded: function() {
        this.isLoaded = true;
        this.isLoading = false;
    },
    removeDisabled: function() {
      console.log("test");
      //Reference the Button.
      event.preventDefault();
      if (this.jQuery("#txtPassportNumber").val() != "") {
        this.isAdd = true;
        this.jQuery("#btnSubmit").prop("disabled", false);
      } else {
        
        this.jQuery("#btnSubmit").prop("disabled", true);
      }
    },

    addTip: function(amount, index) {
    
    this.isOther = false;
    this.isAdd = false;
    this.tipSelected = index;
    localStorage.setItem('index', index);
    this.tipSelectedOther = null;
    this.isclear = false;

    if(!localStorage.getItem("tip")){
        
        localStorage.setItem("tip", amount);
        var data = new this.formdata();
        data.append("session_uuid", this.session_id);
        data.append("language_code", this.lang);
        data.append("tip", amount);
        data.append("manage_type", 1);
        data.append("cancelled_tip", 0);

        var config1 = {
          method: "post",
          data:data,
          url:process.env.VUE_APP_BASE_URI +
            "/api/userapi/restaurant/tip-add/",
          headers: {},
        };
        this.axios(config1).then((response) => {

            this.tip = response.data.data.total_tip;
            this.grand_total = response.data.data.grand_total;
            // this.grand_total = this.grand_total_without_tip + response.data.data.total_tip;
            localStorage.setItem('grand_total', this.grand_total);
            
            this.$forceUpdate();
    });

        
    }

    else if(localStorage.getItem("tip") == amount){

        // localStorage.setItem("tip_amount", amount);
        var data1 = new this.formdata();
        data1.append("session_uuid", this.session_id);
        data1.append("language_code", this.lang);
        data1.append("tip", amount);
        data1.append("manage_type", 0);
        data1.append("cancelled_tip", 0);

        var config2 = {
      method: "post",
      data:data1,
      url:process.env.VUE_APP_BASE_URI +
        "/api/userapi/restaurant/tip-add/",
      headers: {},
    };
    this.axios(config2).then((response) => {
        // this.tip = response.data.data.total_tip;
        // alert(this.grand_total_without_tip);
        // alert(response.data.data.total_tip)
        this.grand_total_without_tip = response.data.data.grand_total;
        this.tip = 0;
        // this.grand_total = this.grand_total_without_tip - response.data.data.total_tip;
        this.grand_total = response.data.data.grand_total;
        this.$forceUpdate();
        localStorage.setItem('grand_total', this.grand_total);
        localStorage.removeItem("tip_amount");
        localStorage.removeItem("tip");
        localStorage.removeItem("index");
        this.isOther = false;
        this.isAdd = false;
        
        this.tipSelected = null;
        
    });
        
    }
    else if(localStorage.getItem("tip") != amount){
      var data3 = new this.formdata();
        data3.append("session_uuid", this.session_id);
        data3.append("language_code", this.lang);
        data3.append("tip", amount);
        data3.append("manage_type", 1);
        data3.append("cancelled_tip", localStorage.getItem("tip"));
        
          var config3 = {
      method: "post",
      data:data3,
      url:process.env.VUE_APP_BASE_URI +
        "/api/userapi/restaurant/tip-add/",
      headers: {},
    };
    this.axios(config3).then((response) => {

        this.tip = response.data.data.total_tip;
        this.grand_total_without_tip = response.data.data.grand_total;
        // this.grand_total = this.grand_total_without_tip + response.data.data.total_tip;
        this.grand_total = response.data.data.grand_total;
        localStorage.setItem('grand_total', this.grand_total);
        localStorage.setItem("tip", amount);
        localStorage.setItem("tip_amount", this.tip);
        this.isOther = false;
        this.isAdd = false;
        this.$forceUpdate();
    });
        
    }

        console.log(index);            
    },
    

    otherAmount: function(index) {
        
        this.tipSelected = index;
        this.isclear = false;
        localStorage.setItem('index', index);
        if(localStorage.getItem("tip")){

              var data1 = new this.formdata();
        data1.append("session_uuid", this.session_id);
        data1.append("language_code", this.lang);
        data1.append("tip", localStorage.getItem("tip"));
        data1.append("manage_type", 0);
        data1.append("cancelled_tip", 0);
        
          var config1 = {
      method: "post",
      data:data1,
      url:process.env.VUE_APP_BASE_URI +
        "/api/userapi/restaurant/tip-add/",
      headers: {},
    };
    this.axios(config1).then((response) => {

        this.tip = response.data.data.total_tip;
        // this.grand_total = this.grand_total_without_tip - response.data.data.total_tip;
        this.grand_total = response.data.data.grand_total;
        localStorage.removeItem("tip_amount")
        localStorage.removeItem("tip")
            // this.isOther = !this.isOther;
            this.tipSelectedOther = null;
            this.isAdd = false;
            this.tipSelected = null;
            this.jQuery('#txtPassportNumber').val('');
            this.$forceUpdate();
    });
        }
        else{
            // this.isOther = !this.isOther;
            this.tipSelectedOther = !this.tipSelectedOther;
            this.isAdd = false;
            this.tipSelected = null;
            this.$forceUpdate();
        }

        //     var tip2 = (this.grand_total_without_tip) * localStorage.getItem("tip")/100;
        //     var total_cart_amount_after_tip2 = this.total_cart_amount - tip2;
        //     this.total_cart_amount = total_cart_amount_after_tip2;
        //     localStorage.removeItem("tip_amount")
        //     localStorage.removeItem("tip")
        //     this.isOther = !this.isOther;
        //     this.tipSelectedOther = !this.tipSelectedOther;
        //     this.isAdd = false;
        //     this.tipSelected = null;
        //     this.jQuery('#txtPassportNumber').val('');
        //     this.$forceUpdate();
            

        // }
        // else{
            // alert('hi')
            this.isOther = !this.isOther;
            this.tipSelectedOther = !this.tipSelectedOther;
            this.isAdd = false;
            this.tipSelected = null;
        // }
    },

    tipAmount: function() {

        this.tipSelectedOther = 4
        var amount = this.jQuery("#txtPassportNumber").val();

        if(!localStorage.getItem("tip")){
        
        localStorage.setItem("tip", amount);
        var data = new this.formdata();
        data.append("session_uuid", this.session_id);
        data.append("language_code", this.lang);
        data.append("tip", amount);
        data.append("manage_type", 1);
        data.append("cancelled_tip", 0);

        var config1 = {
          method: "post",
          data:data,
          url:process.env.VUE_APP_BASE_URI +
            "/api/userapi/restaurant/tip-add/",
          headers: {},
        };
        this.axios(config1).then((response) => {

            this.tip = response.data.data.total_tip;
            // this.grand_total = this.grand_total_without_tip + response.data.data.total_tip;
            this.grand_total = response.data.data.grand_total;
            // this.isOther = false;
            this.isAdd = false;
            this.isclear = true;
            this.tipSelected = null;
            this.$forceUpdate();
    });

        
    }
    else if(localStorage.getItem("tip") == amount){

        // localStorage.setItem("tip_amount", amount);
        var data1 = new this.formdata();
        data1.append("session_uuid", this.session_id);
        data1.append("language_code", this.lang);
        data1.append("tip", amount);
        data1.append("manage_type", 0);
        data1.append("cancelled_tip", 0);

        var config2 = {
      method: "post",
      data:data1,
      url:process.env.VUE_APP_BASE_URI +
        "/api/userapi/restaurant/tip-add/",
      headers: {},
    };
    this.axios(config2).then((response) => {
        // this.tip = response.data.data.total_tip;
        this.tip = 0;
        // this.grand_total = this.grand_total_without_tip - response.data.data.total_tip;
        this.grand_total = response.data.data.grand_total;
        localStorage.removeItem("tip_amount")
        localStorage.removeItem("tip")
        this.isOther = false;
        this.isAdd = false;
        this.tipSelectedOther = null;
        this.$forceUpdate();
    });
        
    }

    else if(localStorage.getItem("tip") != amount){

      var data3 = new this.formdata();
        data3.append("session_uuid", this.session_id);
        data3.append("language_code", this.lang);
        data3.append("tip", amount);
        data3.append("manage_type", 1);
        data3.append("cancelled_tip", localStorage.getItem("tip"));
        
          var config3 = {
      method: "post",
      data:data3,
      url:process.env.VUE_APP_BASE_URI +
        "/api/userapi/restaurant/tip-add/",
      headers: {},
    };
    this.axios(config3).then((response) => {

        this.tip = response.data.data.total_tip;
        // this.grand_total = this.grand_total_without_tip + response.data.data.total_tip;
        this.grand_total = response.data.data.grand_total;
        localStorage.setItem("tip", amount);
        localStorage.setItem("tip_amount", this.tip);
  
        this.$forceUpdate();
    });
        
    }
    },
    clearTip: function(){

      var data1 = new this.formdata();
        data1.append("session_uuid", this.session_id);
        data1.append("language_code", this.lang);
        data1.append("tip", localStorage.getItem("tip"));
        data1.append("manage_type", 0);
        data1.append("cancelled_tip", 0);

        var config2 = {
      method: "post",
      data:data1,
      url:process.env.VUE_APP_BASE_URI +
        "/api/userapi/restaurant/tip-add/",
      headers: {},
    };
    this.axios(config2).then((response) => {
        // this.tip = response.data.data.total_tip;
        this.tip = 0;
        // this.grand_total = this.grand_total_without_tip - response.data.data.total_tip;
        this.grand_total = response.data.data.grand_total;
        localStorage.removeItem("tip_amount");
        localStorage.removeItem("tip");
        localStorage.removeItem("index");
        this.jQuery('#txtPassportNumber').val('');
        this.isOther = false;
        this.isAdd = false;
        this.tipSelectedOther = false;
        this.isclear = false;
        this.$forceUpdate();
    });
    },


    Loader: function(event){
            event.target.src = require("@/assets/website/img/loading.gif");
        },

    addHelp: function(event){
            this.$toast.error(this.$t("message.helpwaiter", {}, { locale: this.lang }),{
            position:"bottom",
            duration:2000
            })
            var config = {
            method: 'get',
                url: process.env.VUE_APP_BASE_URI+'/api/userapi/waiter/help/'+this.session_id+'/',
                headers: {
                }
            };
            this.axios(config)
            .then(response => {
            if(response.status){
                console.log(response.status);
            }
            });
            event.preventDefault();
        },
        getHumanDate : function (date) {
                return moment(date, 'YYYY-MM-DD').format('LLLL');
            },
        openModal: function(){

          if(localStorage.getItem('email')){
            var session_id = localStorage.getItem('session_id');
            var email = localStorage.getItem('email');
            var data = new FormData();
            data.append('session_uuid', session_id);
            data.append('email', email);
            var config = {
                method: 'post',
                data:data,
                url: process.env.VUE_APP_BASE_URI+'/api/userapi/send/orderbill/',
                headers: {
                },
            };
            this.axios(config)
            .then(response => {
            if(response.status){
                this.jQuery("#exampleModalCenter").modal('hide');
                this.$toast.success(this.$t("message.mail_success", {}, { locale: this.lang }),{
                position:"bottom",
                duration:2000
                })
            }else{
                this.$toast.error(this.$t("message.mail_error", {}, { locale: this.lang }),{
                position:"bottom",
                duration:2000
                })
            }
            });

          }
          else{
          this.jQuery("#exampleModalCenter").modal('show');
          }
        },
        payOnline: function(){
          var config3 = {
        method: 'get',
            url: process.env.VUE_APP_BASE_URI+'/api/user/payment/status/'+this.session_id+'/',
            headers: {
            }
        };
        this.axios(config3)
        .then(response => {
        

        
        if(response.data.data.payment_status){
            // alert("already procced");
            
              this.$toast.error(response.data.message,{
                    position:"bottom",
                    duration:3000
                    })
            return false;
        }
        else{
           var config = {
        method: 'get',
            url: process.env.VUE_APP_BASE_URI+'/api/user/payment/status/change/'+this.session_id+'/',
            headers: {
            }
        };
        this.axios(config)
        .then(response => {
        if(response){
          this.jQuery('#payment_form').submit();
        }

        });
        }
        });
      
        },
        finishOrder: function(){
            this.$router.push(
          "/review/"
        );
        },
        payOffline: function(){
            this.$router.push('/payment_success/');
        },
        sendBill: function(){

            var session_id = localStorage.getItem('session_id');
            var email_id = this.jQuery("#email-address").val();
            var data = new FormData();
            data.append('session_uuid', session_id);
            data.append('email', email_id);
            var config = {
                method: 'post',
                data:data,
                url: process.env.VUE_APP_BASE_URI+'/api/userapi/send/orderbill/',
                headers: {
                },
            };
            this.axios(config)
            .then(response => {
            if(response.status){
                this.jQuery("#exampleModalCenter").modal('hide');
                this.$toast.success(this.$t("message.mail_success", {}, { locale: this.lang }),{
                position:"bottom",
                duration:2000
                })
            }else{
                this.$toast.error(this.$t("message.mail_error", {}, { locale: this.lang }),{
                position:"bottom",
                duration:2000
                })
            }
            });
        },
        refreshpage: function(){

            window.location.reload();
        },
        ResimageLoadError: function(event){
        event.target.src = require("@/assets/website/img/logo.png");
    },
        
        handleChange: function(a){
            localStorage.setItem('lang', a);
            this.lang = a;
            
            if (a === 'en-us') {
                this.eng_lang = true;
                // this.thai_lang = false;
                // this.jap_lang = false;
                // this.ko_lang = false;
                // this.it_lang = false;
                // this.ch_lang = false;
                // this.ro_lang = false;
                // this.ru_lang = false;
                // this.uk_lang = false;
                this.lang_select = '';
            }
            else if (a === 'th'){
                // this.thai_lang = true;
                // this.eng_lang = false;
                // this.jap_lang = false;
                // this.ko_lang = false;
                // this.it_lang = false;
                // this.ch_lang = false;
                // this.ro_lang = false;
                // this.ru_lang = false;
                // this.uk_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
            }
            else if (a === 'ko'){
                // this.ko_lang = true;
                // this.thai_lang = false;
                // this.jap_lang = false;
                // this.eng_lang = false;
                // this.it_lang = false;
                // this.ch_lang = false;
                // this.ro_lang = false;
                // this.ru_lang = false;
                // this.uk_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
            }
            else if (a === 'ja'){
                // this.jap_lang = true;
                // this.thai_lang = false;
                // this.eng_lang = false;
                // this.ko_lang = false;
                // this.it_lang = false;
                // this.ch_lang = false;
                // this.ro_lang = false;
                // this.ru_lang = false;
                // this.uk_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
            }
            else if (a === 'it'){
                // this.it_lang = true;
                // this.thai_lang = false;
                // this.jap_lang = false;
                // this.ko_lang = false;
                // this.eng_lang = false;
                // this.ch_lang = false;
                // this.ro_lang = false;
                // this.ru_lang = false;
                // this.uk_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
            }
            else if (a === 'zh-hans'){
                // this.ch_lang = true;
                // this.thai_lang = false;
                // this.jap_lang = false;
                // this.ko_lang = false;
                // this.it_lang = false;
                // this.eng_lang = false;
                // this.ro_lang = false;
                // this.ru_lang = false;
                // this.uk_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
            }
            else if (a === 'ro'){
                // this.ro_lang = true;
                // this.thai_lang = false;
                // this.jap_lang = false;
                // this.ko_lang = false;
                // this.it_lang = false;
                // this.eng_lang = false;
                // this.ch_lang = false;
                // this.ru_lang = false;
                // this.uk_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
            }
            else if (a === 'ru'){
                // this.ru_lang = true;
                // this.thai_lang = false;
                // this.jap_lang = false;
                // this.ko_lang = false;
                // this.it_lang = false;
                // this.eng_lang = false;
                // this.ch_lang = false;
                // this.ro_lang = false;
                // this.uk_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
            }
            else if (a === 'uk'){
                // this.uk_lang = true;
                // this.thai_lang = false;
                // this.jap_lang = false;
                // this.ko_lang = false;
                // this.it_lang = false;
                // this.eng_lang = false;
                // this.ch_lang = false;
                // this.ro_lang = false;
                // this.ru_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
            }

          var config = {
          method: 'get',
          url: process.env.VUE_APP_BASE_URI+'/api/waiter/get/bill/details/'+this.session_id+'/0/2/'+this.lang,
          headers: {
          }
        };
        this.axios(config)
        .then(response => {
          if(response.status){
            var data = response.data.data;
            this.items = data.session_confirmed_item;
            this.tax_calculation = data.taxes_calculation;
            this.grand_total = data.grand_total;
            this.service_fee_amount = data.service_fee_amount;
            this.created_at = data.created_at;
            this.order_id = data.order_id;
          }
        });
                    
        }

  },
  mounted: function(){

    if(!localStorage.getItem('session_id')){
          this.$router.push('/pagenotfound/');
      }

      var session_id = localStorage.getItem('session_id');
      var restaurant_id = localStorage.getItem('restaurant_id');
      var table_id = localStorage.getItem('table_id');
      var currency = localStorage.getItem('currency');
      var lang = localStorage.getItem('lang');
      this.logo = localStorage.getItem('logo');
      this.restaurant_id = restaurant_id;
      this.table_id = table_id;
      this.session_id = session_id;
      this.currency = currency;
      this.lang = lang;
      this.tipSelected = localStorage.getItem('index');

      if(this.tipSelected === '4'){
        this.isOther = true;
        this.amount = localStorage.getItem('tip')
        this.tipSelectedOther = 4;
        this.isclear = true;
      }



      if (this.lang === 'en-us') {
        this.eng_lang = true;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        // this.ch_lang = false;
        // this.ro_lang = false;
        // this.ru_lang = false;
        // this.uk_lang = false;
        this.lang_select = '';
    }
    else if (this.lang  === 'th'){
        // this.thai_lang = true;
        // this.eng_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        // this.ch_lang = false;
        // this.ro_lang = false;
        // this.ru_lang = false;
        // this.uk_lang = false;
        this.lang_select = 'th';
        this.eng_lang = false;

    }
    else if (this.lang  === 'ko'){
        // this.ko_lang = true;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.eng_lang = false;
        // this.it_lang = false;
        // this.ch_lang = false;
        // this.ro_lang = false;
        // this.ru_lang = false;
        // this.uk_lang = false;
        this.lang_select = 'ko';
        this.eng_lang = false;
    }
    else if (this.lang  === 'ja'){
        // this.jap_lang = true;
        // this.thai_lang = false;
        // this.eng_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        // this.ch_lang = false;
        // this.ro_lang = false;
        // this.ru_lang = false;
        // this.uk_lang = false;
        this.lang_select = 'ja';
        this.eng_lang = false;
    }
    else if (this.lang  === 'it'){
        // this.it_lang = true;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.eng_lang = false;
        // this.ch_lang = false;
        // this.ro_lang = false;
        // this.ru_lang = false;
        // this.uk_lang = false;
        this.lang_select = 'it';
        this.eng_lang = false;
    }
    else if (this.lang  === 'zh-hans'){
        // this.ch_lang = true;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        // this.eng_lang = false;
        // this.ro_lang = false;
        // this.ru_lang = false;
        // this.uk_lang = false;
        this.lang_select = 'zh-hans';
        this.eng_lang = false;
    }
    else if (this.lang === 'ro'){
        // this.ro_lang = true;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        // this.eng_lang = false;
        // this.ch_lang = false;
        // this.ru_lang = false;
        // this.uk_lang = false;
        this.lang_select = 'ro';
        this.eng_lang = false;
    }
    else if (this.lang === 'ru'){
        // this.ru_lang = true;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        // this.eng_lang = false;
        // this.ch_lang = false;
        // this.ro_lang = false;
        // this.uk_lang = false;
        this.lang_select = 'ru';
        this.eng_lang = false;
    }
    else if (this.lang === 'uk'){
        // this.uk_lang = true;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        // this.eng_lang = false;
        // this.ch_lang = false;
        // this.ro_lang = false;
        // this.ru_lang = false;
        this.lang_select = 'uk';
        this.eng_lang = false;
    }

    this.isLoaded =  false;
    this.isLoading = true;

      var config = {
      method: 'get',
      url: process.env.VUE_APP_BASE_URI+'/api/waiter/get/bill/details/'+session_id+'/0/2/',
      headers: {
      }
    };
    this.axios(config)
    .then(response => {
      if(response.data.code == 200){
        this.isLoaded =  true;
        this.isLoading = false;

        var data = response.data.data;
        this.items = data.session_confirmed_item;
        this.item_with_taxes = this.items[0].item_with_taxes;
        this.item_without_taxes = this.items[0].item_without_taxes;
        this.tax_calculation = data.taxes_calculation;
        this.first_total = data.item_with_taxes_total_exclude_tax
        this.second_total = data.item_without_taxes_total;
        this.grand_total = data.grand_total;
        this.grand_total_without_tip = data.grand_total;
        this.service_fee_amount = data.service_fee_amount;
        // this.created_at = data.created_at;
        this.order_id = data.order_id;
        this.order_status = data.order_status;
        this.discount = data.discounted_amount;
        this.discount_type = data.discount_type;
        this.discount_value = data.discount_value;
        this.tip = data.total_tip;
        this.bill_amount = data.grand_total_without_discount;
        localStorage.setItem('grand_total', data.grand_total);
        var date = data.created_at.split("T")[0];
        var time = data.created_at.split("T")[1];
        
        var datePart = date.split('-');
        this.mydate = datePart[2]+'/'+datePart[1]+'/'+datePart[0];

        var H = +time.substr(0, 2);
        var h = H % 12 || 12;
        var ampm = (H < 12 || H === 24) ? "AM" : "PM";
        this.timeString = h + time.substr(2, 3) + ampm;
      }


      else{
        // alert("hi");
        var session_id = localStorage.removeItem('session_id');
        this.session_id = session_id;
        
        localStorage.removeItem('pin')
        localStorage.removeItem('order_id')
        // localStorage.removeItem('email')
        // localStorage.removeItem('phone')
        // localStorage.removeItem('name')
        localStorage.removeItem('grand_total')
        localStorage.removeItem('personal_detail')
        localStorage.removeItem('instruction')
        
        window.location.href= '#/'+localStorage.getItem('restaurant_id')+'/'+localStorage.getItem('table_id');
        // this.$router.push('#/'+this.restaurant_id+'/'+this.table_id);
      }
    });
    // var config3 = {
    //     method: 'get',
    //         url: process.env.VUE_APP_BASE_URI+'/api/user/payment/status/'+session_id+'/',
    //         headers: {
    //         }
    //     };
    //     this.axios(config3)
    //     .then(response => {
    //     if(response.data.data.payment_status){
    //       console.log(response.data.data.payment_status);
    //         console.log(response.status);
    //         // alert("already procced");
            
    //           this.$toast.error(this.$t("message.alreadyprocced", {}, { locale: this.lang }),{
    //                 position:"bottom",
    //                 duration:3000
    //                 })
    //         return false;
    //     }
    //      else{
      var sess_id = localStorage.getItem('session_id');

      var data = new FormData();
      data.append('session_uuid', sess_id);
      var config1 = {
          method: 'post',
          data:data,
          url: process.env.VUE_APP_BASE_URI+'ccavRequestHandler/',
          headers: {
          },
      };
      this.axios(config1)
      .then(response => {
      if(response.status){
          this.access_code = response.data.xscode;
          this.encRequest = response.data.encRequest;
      }else{
          this.$toast.error(this.$t("message.mail_error", {}, { locale: this.lang }),{
          position:"bottom",
          duration:2000
          })
      }
      });
      var config2 = {
      method: "get",
      url:process.env.VUE_APP_BASE_URI +
        "/api/userapi/restaurant/tip/" +
          this.session_id +
        "/",
      headers: {},
    };
    this.axios(config2).then((response) => {
        console.log("tip list", response.data.data.tip_list);
        this.tip_list = response.data.data.tip_list;

        // for (var i=0; i<this.tip_list.length; i++) {
        //     this.tip_list[i].push({"key": i, "isSelected":false})
        // }
        console.log("tip list", this.tip_list);
    });

      var config5 = {
      method: "get",
      url:process.env.VUE_APP_BASE_URI +
        "/api/userapi/language/list/" +
        this.restaurant_id +
        "/",
      headers: {},
    };
    this.axios(config5).then((response) => {
      if (response.status) {

          this.lang_list = response.data.data;
        
      }
    });
          

      
    
  }
}
</script>

<style>
a:hover {
  text-decoration: none !important;
}
.frame {
    overflow-y: auto;
	height:108px;	
	}
	.frame::-webkit-scrollbar {
  width: 3px;
}
.frame::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
.frame::-webkit-scrollbar-thumb {
  background: #888; 
}
.frame::-webkit-scrollbar-thumb:hover {
  background: #555; 
}
#btnsubmit{
  color: #ff6426;
    font-weight: 500;
}
td{
font-size:11px;
}
/* .item_ls + .item_ls:before {
  content: ", ";
} */
.item_ls {
    display: block;
} 
.table td, table th {
    padding: 0.45rem !important;
}
.tip{
    border: 1px solid; color: #585657; border-radius: 11px;
}   
.tips{
    border: 1px solid #ff0000;
    color: #ff0000;
}
.bottom-cart{
        background: white;
        padding: 5px 0;
        position: fixed;
        bottom: 0;
        width: 100%;
        z-index: 111;
        box-shadow: rgb(125 125 125 / 45%) 0px 2px 8px;
        margin-top: 20px;
    }
</style>

